<template>
  <div class="tree">
    <ul class="tree-list">
      <node-tree
        :node="treeData"
        @confirm="updatedNode"
        :action="action"
      ></node-tree>
      <br />
      <a href="#" @click="addChild(treeData.children)" class="add-padding"
        >+ Add Criteria</a
      >
    </ul>
  </div>
</template>

<script>
import NodeTree from "@/components/RulesManager/Node.vue";

export default {
  props: {
    treeData: Object,
    action: String
  },
  components: {
    NodeTree
  },
  data() {
    return {
      treeNode: this.treeData
    };
  },
  methods: {
    addChild(node) {
      if (node.children == undefined) {
        node.children = [];
      }
      this.$store.commit("incrementTreeKeyId");
      const key_id = this.$store.state.treeKeyId;
      node.push({
        label: key_id,
        form: {},
        children: []
      });
      this.tree = node;
      this.$store.state.treeRule = this.treeData;
      //this.action == "Add" ? this.$emit("confirm", this.treeNode) : "";
    },
    updatedNode(node) {
      this.treeNode = node;
      this.$emit("confirm", this.treeNode);
    }
  }
};
</script>
